import { useEffect, useState } from 'react';
import UiError from '../../components/UiError';
import { deleteDatasetContribution, getDatasetContribution } from './api';
import { getDatasetReceipts } from './receipts';
import './dataset.css';

export default function ContributionsManager() {
  const [items, setItems] = useState(() => getDatasetReceipts().map((receipt) => ({ ...receipt, state: 'loading' })));

  useEffect(() => {
    let cancelled = false;
    Promise.all(getDatasetReceipts().map(async (receipt) => {
      try {
        return { ...receipt, ...(await getDatasetContribution(receipt.submissionId, receipt.token)) };
      } catch (error) {
        return { ...receipt, state: 'unavailable', error: error.message };
      }
    })).then((next) => { if (!cancelled) setItems(next); });
    return () => { cancelled = true; };
  }, []);

  const withdraw = async (item) => {
    setItems((current) => current.map((candidate) => candidate.submissionId === item.submissionId ? { ...candidate, state: 'deleting' } : candidate));
    try {
      await deleteDatasetContribution(item.submissionId, item.token);
      setItems((current) => current.filter((candidate) => candidate.submissionId !== item.submissionId));
    } catch (error) {
      setItems((current) => current.map((candidate) => candidate.submissionId === item.submissionId ? { ...candidate, state: 'error', error: error.message } : candidate));
    }
  };

  return (
    <main className="contributions-manager">
      <h1>Les teves aportacions</h1>
      <p>Els rebuts es guarden només en aquest dispositiu. Amb el token anònim pots consultar o retirar cada aportació.</p>
      {items.length === 0 && <p>No hi ha cap aportació desada en aquest dispositiu.</p>}
      <ul>
        {items.map((item) => (
          <li key={item.submissionId}>
            <code>{item.submissionId}</code>
            <span>Estat: {item.state}</span>
            {item.error && <UiError as="span" context="dataset-contribution">{item.error}</UiError>}
            <button type="button" disabled={item.state === 'loading' || item.state === 'deleting'} onClick={() => withdraw(item)}>Retira i elimina</button>
          </li>
        ))}
      </ul>
      <a href="/">Torna al transcriptor</a>
    </main>
  );
}
